import React from 'react';
import PropTypes from 'prop-types';
import { ListGroup, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SetupChecklistContent from './SetupChecklistContent';
import { setupChecklistUiIcons } from './setupChecklistData';

export default function SetupChecklistRow({
  item, isOpen, onToggle, onCallToAction,
}) {
  return (
    <ListGroup.Item
      as="li"
      className={`px-2 ${item.premium ? 'ra-row-premium' : ''}`}
    >
      <button
        type="button"
        className="btn btn-link d-flex align-items-center w-100 p-0 text-left text-decoration-none text-reset ra-row-header"
        onClick={() => onToggle(item.itemId)}
        aria-expanded={isOpen}
      >
        <FontAwesomeIcon
          icon={item.icon}
          className="mr-3 ra-row-icon"
          aria-hidden="true"
          size="2x"
        />
        <span className="ra-row-title">{item.title}</span>
        {item.premium && (
          <FontAwesomeIcon
            icon={setupChecklistUiIcons.gem}
            className="ml-2 ra-row-premium-icon"
            aria-label="Premium feature"
          />
        )}
        <FontAwesomeIcon
          icon={setupChecklistUiIcons.chevronDown}
          className={`ml-auto ra-row-chevron ${isOpen ? 'ra-row-chevron-open' : ''}`}
          aria-hidden="true"
        />
      </button>
      {isOpen && (
        <div className="pt-2 pb-3 pl-5 pr-2 ra-row-content">
          {item.premium && (
            <Alert variant="warning" className="py-2 px-3 small">
              This feature isn&apos;t available at your current subscription tier.
              {' '}
              <Alert.Link href="/s/subscription/billing/change-plan">See upgrade options</Alert.Link>
              .
            </Alert>
          )}
          <div className={item.premium ? 'text-muted' : ''}>
            <SetupChecklistContent blocks={item.content} onCallToAction={onCallToAction} />
          </div>
        </div>
      )}
    </ListGroup.Item>
  );
}

SetupChecklistRow.propTypes = {
  item: PropTypes.shape({
    itemId: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    icon: PropTypes.object.isRequired,
    premium: PropTypes.bool,
    content: PropTypes.array.isRequired,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onCallToAction: PropTypes.func,
};

SetupChecklistRow.defaultProps = {
  onCallToAction: undefined,
};
